module.exports = __webpack_public_path__ + "img/rebuild_yeh_mob2.5d434c11.jpg";